import type { ReactNode } from "react";
import { useContext, useEffect, useRef } from "react";
import { UNSAFE_DataRouterContext as DataRouterContext } from "react-router";
import type { INavItem } from "src/components/layouts";
import { useAppNavigation } from "src/contexts/AppNavigationContext";
import { useRouteMetadata } from "src/hooks/useRouteMetadata";

export default function RouteMetadataSync(): ReactNode {
    const dataRouter = useContext(DataRouterContext);
    return dataRouter ? <RouteMetadataSyncInner /> : null;
}

const navItemsSignature = (items: INavItem[]): string => items.map(item => [
    item.title,
    item.url ?? "",
    item.target ?? "",
    item.current ? "1" : "0",
    item.description ?? "",
    item.icon?.prefix ?? "",
    item.icon?.iconName ?? "",
].join("\u001f")).join("\u001e");

function RouteMetadataSyncInner(): null {
    const { setBreadcrumbs, clearBreadcrumbs, setDrawerItems } = useAppNavigation();
    const metadata = useRouteMetadata();
    const metadataRef = useRef(metadata);
    metadataRef.current = metadata;
    const breadcrumbSignature = navItemsSignature(metadata.breadcrumbs);
    const drawerSignature = navItemsSignature(metadata.drawerItems);
    useEffect(() => {
        const currentMetadata = metadataRef.current;
        document.title = `${currentMetadata.title} | BCT Trial Management`;
        if (currentMetadata.breadcrumbs.length > 0) setBreadcrumbs(currentMetadata.breadcrumbs);
        else clearBreadcrumbs();
        setDrawerItems(currentMetadata.drawerItems);
        return () => {
            clearBreadcrumbs();
            setDrawerItems([]);
        };
    }, [breadcrumbSignature, clearBreadcrumbs, drawerSignature, metadata.title, setBreadcrumbs, setDrawerItems]);
    return null;
}
